import McpToolCreate from './McpToolCreate'
import McpToolEdit from './McpToolEdit'

export default {
  create: McpToolCreate,
  edit: McpToolEdit,
}
